import { render, staticRenderFns } from "./PremiumSettings.vue?vue&type=template&id=db97eeba&scoped=true&"
import script from "./PremiumSettings.vue?vue&type=script&lang=js&"
export * from "./PremiumSettings.vue?vue&type=script&lang=js&"
import style0 from "./PremiumSettings.vue?vue&type=style&index=0&id=db97eeba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db97eeba",
  null
  
)

export default component.exports